// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file campaign.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file campaign.proto.
 */
export const file_campaign: GenFile = /*@__PURE__*/
  fileDesc("Cg5jYW1wYWlnbi5wcm90bxILZ3JwYy5hcGkudjEiPgoIQ2FtcGFpZ24SCgoCaWQYASABKAMSEQoJc3ViZG9tYWluGAIgASgJEhMKC2Rlc2NyaXB0aW9uGAMgASgJQgZaBC47cGJiBnByb3RvMw");

/**
 * Campaign
 *
 * @generated from message grpc.api.v1.Campaign
 */
export type Campaign = Message<"grpc.api.v1.Campaign"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string subdomain = 2;
   */
  subdomain: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message grpc.api.v1.Campaign.
 * Use `create(CampaignSchema)` to create a new message.
 */
export const CampaignSchema: GenMessage<Campaign> = /*@__PURE__*/
  messageDesc(file_campaign, 0);

